import React from 'react';
import Stack from '../Stack';

export type CenteredFormRowOwnProps = {
    children: React.ReactNode;
    maxWidth?: number | '100%';
};

export type CenteredFormRowProps = CenteredFormRowOwnProps;

export const maxFormWidth = 640;

const CenteredFormRow: React.FC<CenteredFormRowProps> = (props) => {
    return (
        <Stack horizontal fullWidth justify="center">
            <Stack
                horizontal
                fullWidth
                justify="center"
                style={{
                    maxWidth: props.maxWidth || maxFormWidth,
                }}
            >
                {props.children}
            </Stack>
        </Stack>
    );
};

export default React.memo(CenteredFormRow);
